// Display formatting helper for ConfiguredServiceActivityAccordion cells (ported/adapted from legacy utils)
// Centralize label/value/color decisions to keep cell renderer free of chained ternaries.

type ActivityDisplayRow = {
  changeType?: string
  field?: string
  fieldKey?: string
  containerName?: string
  oldValue?: unknown
  newValue?: unknown
}

export type ActivityCellDisplay = {
  isGeoCoords?: boolean
  isRemovedContainer?: boolean
  titleText?: string
  changeColor?: string
  valueVariant?: 'none' | 'single' | 'pair'
  singleSource?: 'new' | 'old' | null
  showOnContainer?: boolean
}

const isEmptyVal = (value: unknown): boolean => value === null || value === undefined || value === '' || value === 'None'

export const getActivityCellDisplay = (row?: ActivityDisplayRow | null): ActivityCellDisplay => {
  if (!row) return {}
  const { changeType, field, fieldKey, containerName } = row
  const isGeoCoords = fieldKey === 'geoLocation'
  const isRemovedContainer = changeType === 'Removed' && isGeoCoords && !!containerName

  let titleText = field
  if (isRemovedContainer) {
    titleText = containerName
  } else if (containerName) {
    if (fieldKey === 'containerName') titleText = 'Name'
    else if (fieldKey === 'geoLocation') titleText = 'Coordinates'
    else titleText = field
  }

  let changeColor = 'info.light'
  if (changeType === 'Added' || changeType === 'Assigned') changeColor = 'success.light'
  else if (changeType === 'Deleted' || changeType === 'Removed' || changeType === 'Unassigned') changeColor = 'error.light'

  let valueVariant: ActivityCellDisplay['valueVariant'] = 'none'
  let singleSource: ActivityCellDisplay['singleSource'] = null
  if (changeType === 'Added' || changeType === 'Assigned') {
    valueVariant = 'single'
    singleSource = 'new'
  } else if (changeType === 'Deleted' || changeType === 'Unassigned') {
    valueVariant = 'single'
    singleSource = 'old'
  } else if (changeType === 'Updated' || changeType === 'Moved') {
    valueVariant = 'pair'
  }

  if (
    (changeType === 'Deleted' || changeType === 'Added' || changeType === 'Assigned' || changeType === 'Unassigned') &&
    isEmptyVal(row?.oldValue) &&
    isEmptyVal(row?.newValue)
  ) {
    valueVariant = 'none'
    singleSource = null
  }

  const showOnContainer = !!containerName && !isRemovedContainer

  return {
    isGeoCoords,
    isRemovedContainer,
    titleText,
    changeColor,
    valueVariant,
    singleSource,
    showOnContainer,
  }
}
